import React, { useEffect, useState, useRef } from 'react';
const prefersReducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'left' | 'right' | 'none';
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(prefersReducedMotion);
  useEffect(() => {
    if (prefersReducedMotion) return;
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '150px 0px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const translateY = direction === 'up' ? '16px' : '0px';
  const translateX = direction === 'left' ? '16px' : direction === 'right' ? '-16px' : '0px';
  return <div ref={ref} className={className} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translate3d(0, 0, 0)' : `translate3d(${translateX}, ${translateY}, 0)`,
    transition: prefersReducedMotion ? 'none' : `opacity 0.4s ease ${delay}s, transform 0.4s ease ${delay}s`,
    willChange: isVisible ? 'auto' : 'opacity, transform'
  }} data-id="element-107">
      {children}
    </div>;
}